import { render } from "./SvgMx3Invert.vue?vue&type=template&id=61ec050b&scoped=true"
import script from "./SvgMx3Invert.vue?vue&type=script&lang=js"
export * from "./SvgMx3Invert.vue?vue&type=script&lang=js"

import "./SvgMx3Invert.vue?vue&type=style&index=0&id=61ec050b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec050b"]])

export default __exports__